export enum TrafficRequestChatActionEnum {
  MESSAGE = "MESSAGE",
  EVENT = "EVENT"
}